import { TicketTier, TicketTierRow, Wedding } from "../types";

/** Invite-list tiers: capacity is not tracked (guest list is the inventory). */
export const TIERS_WITHOUT_CAPACITY: TicketTier[] = [
  "party_not_presents",
  "inner_circle_plus_more",
];

export const tierTracksCapacity = (tierType?: string | null): boolean =>
  Boolean(tierType) && !TIERS_WITHOUT_CAPACITY.includes(tierType as TicketTier);

export const activeTiers = (wedding: Wedding | null | undefined): TicketTierRow[] =>
  (wedding?.ticket_tiers || []).filter((t) => t.is_active);

export const ghostTierPrice = (wedding: Wedding | null | undefined): number => {
  const ghost = activeTiers(wedding).find((t) => t.tier_type === "ghost_seats");
  if (ghost) return ghost.price_cents;
  return wedding?.ticket_price || 0;
};

export const partyTierPrice = (wedding: Wedding | null | undefined): number => {
  const party = activeTiers(wedding).find((t) => t.tier_type === "party_not_presents");
  if (party) return party.price_cents;
  return wedding?.ticket_price || 0;
};

export const tierPriceForGuest = (
  wedding: Wedding | null | undefined,
  guestTier?: string | null
): number => {
  if (!guestTier) return partyTierPrice(wedding);
  const row = activeTiers(wedding).find((t) => t.tier_type === guestTier);
  if (row) return row.price_cents;
  if (guestTier === "inner_circle_plus_more") return 0;
  return partyTierPrice(wedding);
};

export const weddingRequiresPayment = (wedding: Wedding | null | undefined): boolean => {
  if (!wedding) return false;
  if (activeTiers(wedding).some((t) => t.price_cents > 0)) return true;
  return (wedding.ticket_price || 0) > 0;
};
